export default "{\n    \"emptyText\": \"Haga clic para seleccionar un proveedor\",\n    \"placeholderText\": \"Buscar por nombre\"\n}\n"